import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { fmtDateTime } from "../lib/api";
import BrandLogo from "../components/BrandLogo";
import { applySeo } from "../lib/seo";

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    api.get(`/public/legal-pages/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true));
  }, [slug]);

  useEffect(() => {
    if (!page) return;
    api.get("/public/seo/platform").then((r) => applySeo({
      ...r.data, title: `${page.title} | MILTROO`,
      canonical: `${r.data.base_url}/legal/${slug}`,
    })).catch(() => {});
  }, [page, slug]);

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="legal-page">
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo"><BrandLogo size="md" /></Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" /> Home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-14">
        {missing ? (
          <>
            <h1 className="font-display font-extrabold text-3xl tracking-tight" data-testid="legal-missing">Page not available</h1>
            <p className="text-sm text-muted-foreground mt-3">This legal page is not published yet or does not exist.</p>
          </>
        ) : !page ? (
          <p className="text-sm text-muted-foreground">Loading…</p>
        ) : (
          <>
            <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight" data-testid="legal-title">{page.title}</h1>
            <p className="text-xs text-muted-foreground mt-2">Last updated: {fmtDateTime(page.updated_at)}</p>
            <div className="mt-8 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap" data-testid="legal-body">
              {page.content || "Content coming soon."}
            </div>
          </>
        )}
      </main>
    </div>
  );
}
